import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fc1c3f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-hidden-desktop" }
const _hoisted_2 = { class: "is-hidden-touch title-four mb-0" }
const _hoisted_3 = { class: "custom-navbar-style navbar is-transparent mb-1" }
const _hoisted_4 = { class: "navbar-brand" }
const _hoisted_5 = { class: "is-flex mr-3" }
const _hoisted_6 = { class: "navbar-item mb-0 p-0 title-four title-overflow" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "navbar-start" }
const _hoisted_12 = { class: "icon" }
const _hoisted_13 = { class: "fa fa-angle-down" }
const _hoisted_14 = { class: "fa fa-angle-up" }
const _hoisted_15 = { class: "navbar-dropdown" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["accept"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider mx-4" }, null, -1))
const _hoisted_19 = { class: "icon" }
const _hoisted_20 = { class: "fa fa-angle-down" }
const _hoisted_21 = { class: "fa fa-angle-up" }
const _hoisted_22 = { class: "navbar-dropdown" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "icon" }
const _hoisted_25 = { class: "fa fa-angle-down" }
const _hoisted_26 = { class: "fa fa-angle-up" }
const _hoisted_27 = { class: "navbar-dropdown" }
const _hoisted_28 = ["disabled", "id", "onClick"]
const _hoisted_29 = { class: "icon" }
const _hoisted_30 = { class: "fa fa-angle-down" }
const _hoisted_31 = { class: "fa fa-angle-up" }
const _hoisted_32 = { class: "navbar-dropdown" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "icon" }
const _hoisted_35 = { class: "fa fa-angle-down" }
const _hoisted_36 = { class: "fa fa-angle-up" }
const _hoisted_37 = { class: "navbar-dropdown" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "table" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Property"),
    /*#__PURE__*/_createElementVNode("th", null, "Value")
  ])
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Name", -1))

import SliderInput from '@/components/common/SliderInput.vue'
import BaseModal from '@/components/common/modal/BaseModal.vue'
import {
  acceptedFileTypes,
  CuttingPlaneType,
  getRawValue,
  HoopsDrawModeOptions,
  HoopsModelView,
  HoopsOrientationAndProjectionOptionsForMobile,
  HoopsPerspective,
  HoopsSlice,
  HoopsSliceOptionsForMobile,
} from '@/plugins/hoops'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { CuttingPlaneState } from '@/store/modules/hoopsWebViewer'
import { useStore } from 'vuex'

import DrawMode = Communicator.DrawMode

export default /*#__PURE__*/_defineComponent({
  __name: 'TopToolbarMobile',
  props: {
  disabled: Boolean, // affects all buttons except upload
  hasCloseOption: Boolean, // add and emit close option, useful for modals
  hasEditOptions: Boolean, // controls visibility of properties, upload and delete option
  hasFileProcessing: Boolean, // disables upload option
  title: String
},
  emits: ['close', 'delete', 'upload'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const fileInput = ref<HTMLInputElement | null>(null)
const props = __props

const store = useStore()
const captureSnapshot = () => {
  store.dispatch('hoopsWebViewer/captureSnapshot')
  isBurgerMenuOpen.value = false
}
const changeModelView = async (modelView: HoopsModelView) => {
  await store.dispatch('hoopsWebViewer/changeModelView', modelView)
  isBurgerMenuOpen.value = false
}
const currentModelView = computed(() => store.getters['hoopsWebViewer/currentModelView'])
const dismissDeleteModal = () => showDeleteModal.value = false
const dismissPropertiesModal = () => showPropertiesModal.value = false
const showDeleteModal = ref(false)
const showPropertiesModal = ref(false)
const modelProperties = computed( () => store.getters['hoopsWebViewer/modelProperties'])
const modelViewOptions = computed( () => store.getters['hoopsWebViewer/modelViewOptions'])

// mobile variables
const isDrawModeDropdownOpen = ref(false)
const isSliceDropdownOpen = ref(false)
const isOrientationDropdownOpen = ref(false)
const isProjectionDropdownOpen = ref(false)
const isViewDropdownOpen = ref(false)
const isBurgerMenuOpen = ref(false) // relevant in mobile resolutions ( < 1024px )

const toggleDrawModeDropdown = () => {
  if (!props.disabled) {
    isDrawModeDropdownOpen.value = !isDrawModeDropdownOpen.value
  }
}
const toggleOrientationDropdown = () => {
  if (!props.disabled) {
    isOrientationDropdownOpen.value = !isOrientationDropdownOpen.value
  }
}
const toggleProjectionDropdown = () => {
  if (!props.disabled) {
    isProjectionDropdownOpen.value = !isProjectionDropdownOpen.value
  }
}
const toggleSliceDropdown = () => {
  if (!props.disabled) {
    isSliceDropdownOpen.value = !isSliceDropdownOpen.value
  }
}
const toggleViewDropdown = () => {
  if (!props.disabled) {
    isViewDropdownOpen.value = !isViewDropdownOpen.value
  }
}

// bottom toolbar
const currentDrawMode = computed(() => store.getters['hoopsWebViewer/currentDrawMode'])
const currentExplodeMagnitude = computed({
  get () {
    return store.getters['hoopsWebViewer/currentExplodeMagnitude']
  },
  set (newMagnitude: number) {
    store.dispatch('hoopsWebViewer/changeExplodeMagnitude', newMagnitude)
  }
})
const currentProjection = computed(() => store.getters['hoopsWebViewer/currentProjection'])
const currentOrientation = computed(() => store.getters['hoopsWebViewer/currentOrientation'])

// Orientation or Projection
const changePerspective = async (projection: HoopsPerspective) => {
  isBurgerMenuOpen.value = false
  closeDropdowns()
  await store.dispatch('hoopsWebViewer/changePerspective', projection)
}
const changeDrawMode = async (mode: DrawMode) => {
  isBurgerMenuOpen.value = false
  closeDropdowns()
  await store.dispatch('hoopsWebViewer/changeDrawMode', mode)
}
const changeSliceMode = (option: HoopsSlice) => {
  switch (option.type) {
    case CuttingPlaneType.PLANE_SECTION:
      store.dispatch('hoopsWebViewer/toggleCuttingPlaneSection')
      break
    case CuttingPlaneType.PLANE_VISIBILITY:
      store.dispatch('hoopsWebViewer/toggleCuttingPlaneVisibility')
      break
    case CuttingPlaneType.PLANE_X:
      store.dispatch('hoopsWebViewer/toggleCuttingPlaneX')
      break
    case CuttingPlaneType.PLANE_Y:
      store.dispatch('hoopsWebViewer/toggleCuttingPlaneY')
      break
    case CuttingPlaneType.PLANE_Z:
      store.dispatch('hoopsWebViewer/toggleCuttingPlaneZ')
      break
    case CuttingPlaneType.RESET:
      store.dispatch('hoopsWebViewer/removeAllCuttingPlanes')
      break
    default:
    // CuttingPlaneType.PLANE_FACE is unused for part
  }
}
const resetCameraView = async () => {
  await store.dispatch('hoopsWebViewer/resetCameraView')
  isBurgerMenuOpen.value = false
  closeDropdowns()
}
const zoomIn = () => store.dispatch('hoopsWebViewer/zoomIn')
const zoomOut = () => store.dispatch('hoopsWebViewer/zoomOut')

/**
 * Helper to reset/close dropdowns when burger menu closes
 */
const closeDropdowns = () => {
  if (!isBurgerMenuOpen.value) {
    isDrawModeDropdownOpen.value = false
    isOrientationDropdownOpen.value = false
    isProjectionDropdownOpen.value = false
    isSliceDropdownOpen.value = false
    isViewDropdownOpen.value = false
  }
}
/**
 * Slice options can have two-states and three-states. :|
 * @param option
 */
const getSliceStyleClass = (option: HoopsSlice) => {
  function getClassForThreeState (state: CuttingPlaneState) {
    switch (state) {
      case CuttingPlaneState.OFF:
        return null
      case CuttingPlaneState.POSITIVE:
        return 'has-background-primary'
      case CuttingPlaneState.NEGATIVE:
        return 'has-background-primary-dark has-text-white'
    }
  }

  switch (option.type) {
    case CuttingPlaneType.PLANE_SECTION:
      return store.getters['hoopsWebViewer/cuttingPlaneSectionEnabled'] ?
        'has-background-primary' : null
    case CuttingPlaneType.PLANE_VISIBILITY:
      return store.getters['hoopsWebViewer/cuttingPlaneVisibilityEnabled'] ?
        'has-background-primary' : null
    case CuttingPlaneType.PLANE_X:
      return getClassForThreeState(store.getters['hoopsWebViewer/cuttingPlaneXState'])
    case CuttingPlaneType.PLANE_Y:
      return getClassForThreeState(store.getters['hoopsWebViewer/cuttingPlaneYState'])
    case CuttingPlaneType.PLANE_Z:
      return getClassForThreeState(store.getters['hoopsWebViewer/cuttingPlaneZState'])
    case CuttingPlaneType.RESET:
      return // No color classes for RESET
    default:
    // PLANE_FACE is unused for part
  }
}

const isDisabledSliceOption = (option: HoopsSlice) => {
  switch (option.type) {
    case CuttingPlaneType.PLANE_SECTION:
      return store.getters['hoopsWebViewer/cuttingPlanesCount'] < 2 ? true : null
    case CuttingPlaneType.PLANE_VISIBILITY:
    case CuttingPlaneType.RESET:
      return store.getters['hoopsWebViewer/cuttingPlanesCount'] === 0 ? true : null
    default:
      return null // PLANE_FACE is unused for part
  }
}
// end of bottom toolbar

const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement

  if (target.files && target.files.length > 0) {
    emit('upload', Array.from(target.files))
  }
  target.value = ''
}
const toggleBurgerMenu = () => {
  isBurgerMenuOpen.value = !isBurgerMenuOpen.value
  if (!isBurgerMenuOpen.value) {
    closeDropdowns()
  }
}
const triggerFileInput = () => {
  if (fileInput.value) {
    fileInput.value.click();
  }
  isBurgerMenuOpen.value = false
  closeDropdowns()
}
const handleOpenForPropertiesModal = () => {
  if (isBurgerMenuOpen.value) {
    showPropertiesModal.value = true
    isBurgerMenuOpen.value = false
    closeDropdowns()
  }
}
const handleOpenForDeleteModal = () => {
  isBurgerMenuOpen.value = false
  closeDropdowns()
  showDeleteModal.value = true
}
const handleSubmitForDeleteModal = async () => {
  emit('delete')
  showDeleteModal.value = false
}

const navbarClickawayEventListener = (event: Event) => {
  const navbarBurger = document.getElementById('part-3d-navbar-burger-mobile');
  const navbarMenu = document.getElementById('part-3d-navbar-menu-mobile');

  if (!navbarBurger || !navbarMenu) {
    console.warn('Missing Part 3D navbar item(s) for clickaway')
    return
  }

  const target = event.target as HTMLElement;

  if (!navbarMenu.contains(target) && !navbarBurger.contains(target)) {
    isBurgerMenuOpen.value = false;
    closeDropdowns()
    navbarBurger.classList.remove('is-active');
    navbarMenu.classList.remove('is-active');
  }
}

const resizeEventListener = () => {
  isBurgerMenuOpen.value = false
  closeDropdowns()
}

onMounted(() => {
  document.addEventListener('click', navbarClickawayEventListener);
  window.addEventListener('resize', resizeEventListener);
})
onBeforeUnmount(() => {
  document.removeEventListener('click', navbarClickawayEventListener);
  window.removeEventListener('resize', resizeEventListener);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('threeD.viewerTitle')), 1),
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", _hoisted_6, _toDisplayString(__props.title ?? _ctx.$t('threeD.viewerTitle')), 1)
        ]),
        _createElementVNode("a", {
          "aria-expanded": "false",
          "aria-label": "menu",
          class: _normalizeClass(["navbar-burger", { 'is-active': isBurgerMenuOpen.value }]),
          id: "part-3d-navbar-burger-mobile",
          role: "button",
          onClick: toggleBurgerMenu
        }, _hoisted_10, 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["navbar-menu mb-0", { 'is-active': isBurgerMenuOpen.value }]),
        id: "part-3d-navbar-menu-mobile"
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: _normalizeClass(["has-dropdown navbar-item", { 'is-active': isViewDropdownOpen.value, 'is-hoverable': modelViewOptions.value.length > 0 }])
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["burger-item-styling custom-dropdown is-arrowless navbar-link", { 'custom-disabled': __props.disabled || modelViewOptions.value.length === 0 }]),
              onClick: toggleViewDropdown
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('view')), 1),
              _createElementVNode("span", _hoisted_12, [
                _withDirectives(_createElementVNode("i", _hoisted_13, null, 512), [
                  [_vShow, !isViewDropdownOpen.value]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_14, null, 512), [
                  [_vShow, isViewDropdownOpen.value]
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelViewOptions.value, (option) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: _normalizeClass(["navbar-item", { 'is-selected': currentModelView.value?.nodeId === option.nodeId }]),
                  style: _normalizeStyle({ 'display': isViewDropdownOpen.value ? 'block' : 'none' }),
                  onClick: ($event: any) => (changeModelView(option))
                }, _toDisplayString(option.label), 15, _hoisted_16))
              }), 256))
            ], 512), [
              [_vShow, modelViewOptions.value.length > 0 && isViewDropdownOpen.value]
            ])
          ], 2),
          _createElementVNode("a", {
            class: _normalizeClass(["burger-item-styling navbar-item", { 'custom-disabled': __props.disabled }]),
            onClick: captureSnapshot
          }, _toDisplayString(_ctx.$t('snapshot')), 3),
          (__props.hasEditOptions)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: _normalizeClass(["burger-item-styling navbar-item", { 'custom-disabled': __props.disabled, 'is-hoverable': !__props.disabled }]),
                onClick: handleOpenForPropertiesModal
              }, _toDisplayString(_ctx.$tc('property', 2)), 3))
            : _createCommentVNode("", true),
          (__props.hasEditOptions)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: _normalizeClass(["navbar-item", { 'custom-disabled': __props.hasFileProcessing }]),
                onClick: triggerFileInput
              }, _toDisplayString(_ctx.$t('upload')), 3))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            class: "is-hidden",
            multiple: "",
            ref_key: "fileInput",
            ref: fileInput,
            type: "file",
            accept: _unref(acceptedFileTypes),
            onChange: handleFileChange
          }, null, 40, _hoisted_17),
          (__props.hasEditOptions)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                class: _normalizeClass(["navbar-item", { 'custom-disabled': __props.disabled }]),
                onClick: handleOpenForDeleteModal
              }, _toDisplayString(_ctx.$t('delete')), 3))
            : _createCommentVNode("", true),
          (__props.hasCloseOption)
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                class: _normalizeClass(["navbar-item", { 'custom-disabled': __props.disabled }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
              }, _toDisplayString(_ctx.$t('close')), 3))
            : _createCommentVNode("", true),
          _hoisted_18,
          _createElementVNode("a", {
            class: _normalizeClass(["is-arrowless navbar-item", { 'custom-disabled': __props.disabled }]),
            onClick: resetCameraView
          }, _toDisplayString(_ctx.$t('threeD.resetCamera')), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["has-dropdown navbar-item", { 'is-hoverable': !__props.disabled }])
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["burger-item-styling custom-dropdown is-arrowless navbar-link", { 'custom-disabled': __props.disabled }]),
              onClick: toggleDrawModeDropdown
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('threeD.drawMode.label')), 1),
              _createElementVNode("span", _hoisted_19, [
                _withDirectives(_createElementVNode("i", _hoisted_20, null, 512), [
                  [_vShow, !isDrawModeDropdownOpen.value]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_21, null, 512), [
                  [_vShow, isDrawModeDropdownOpen.value]
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HoopsDrawModeOptions), (option) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: `${option.iconType}-${currentDrawMode.value}`,
                  class: _normalizeClass(["navbar-item", { 'has-background-primary': currentDrawMode.value === option.value, 'is-selected': currentDrawMode.value === option.value }]),
                  style: _normalizeStyle({ 'display': isDrawModeDropdownOpen.value ? 'block' : 'none' }),
                  onClick: ($event: any) => (changeDrawMode(option.value))
                }, _toDisplayString(_ctx.$t(option.labelKey)), 15, _hoisted_23))
              }), 128))
            ], 512), [
              [_vShow, isDrawModeDropdownOpen.value]
            ])
          ], 2),
          _createElementVNode("a", {
            class: _normalizeClass(["burger-item-styling navbar-item", { 'custom-disabled': __props.disabled }])
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('threeD.explode')) + " ", 1),
            _createVNode(SliderInput, {
              modelValue: currentExplodeMagnitude.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentExplodeMagnitude).value = $event)),
              class: "mt-2",
              disabled: __props.disabled
            }, null, 8, ["modelValue", "disabled"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["has-dropdown navbar-item", { 'is-hoverable': !__props.disabled }])
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["burger-item-styling custom-dropdown is-arrowless navbar-link", { 'custom-disabled': __props.disabled }]),
              onClick: toggleSliceDropdown
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('threeD.slice.label')) + " ", 1),
              _createElementVNode("span", _hoisted_24, [
                _withDirectives(_createElementVNode("i", _hoisted_25, null, 512), [
                  [_vShow, !isSliceDropdownOpen.value]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_26, null, 512), [
                  [_vShow, isSliceDropdownOpen.value]
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HoopsSliceOptionsForMobile), (option) => {
                return _withDirectives((_openBlock(), _createElementBlock("a", {
                  class: _normalizeClass(["navbar-item", getSliceStyleClass(option)]),
                  disabled: isDisabledSliceOption(option),
                  id: `${option.elementId}`,
                  onClick: ($event: any) => (isDisabledSliceOption(option) ? null : changeSliceMode(option))
                }, _toDisplayString(_ctx.$t(option.labelKey)), 11, _hoisted_28)), [
                  [_vShow, isSliceDropdownOpen.value]
                ])
              }), 256))
            ], 512), [
              [_vShow, isSliceDropdownOpen.value]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["has-dropdown navbar-item", { 'is-hoverable': !__props.disabled }])
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["burger-item-styling custom-dropdown is-arrowless navbar-link", { 'custom-disabled': __props.disabled }]),
              onClick: toggleOrientationDropdown
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('orientation')) + " ", 1),
              _createElementVNode("span", _hoisted_29, [
                _withDirectives(_createElementVNode("i", _hoisted_30, null, 512), [
                  [_vShow, !isOrientationDropdownOpen.value]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_31, null, 512), [
                  [_vShow, isOrientationDropdownOpen.value]
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HoopsOrientationAndProjectionOptionsForMobile).get('orientation'), (option) => {
                return _withDirectives((_openBlock(), _createElementBlock("a", {
                  class: _normalizeClass(["navbar-item", { 'has-background-primary': _unref(getRawValue)(option) === currentOrientation.value }]),
                  onClick: ($event: any) => (changePerspective(option))
                }, _toDisplayString(_ctx.$t(option.labelKey)), 11, _hoisted_33)), [
                  [_vShow, isOrientationDropdownOpen.value]
                ])
              }), 256))
            ], 512), [
              [_vShow, isOrientationDropdownOpen.value]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["has-dropdown navbar-item", { 'is-hoverable': !__props.disabled }])
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["burger-item-styling custom-dropdown is-arrowless navbar-link", { 'custom-disabled': __props.disabled }]),
              onClick: toggleProjectionDropdown
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('threeD.orientationAndProjection.projection')) + " ", 1),
              _createElementVNode("span", _hoisted_34, [
                _withDirectives(_createElementVNode("i", _hoisted_35, null, 512), [
                  [_vShow, !isProjectionDropdownOpen.value]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_36, null, 512), [
                  [_vShow, isProjectionDropdownOpen.value]
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HoopsOrientationAndProjectionOptionsForMobile).get('projection'), (option) => {
                return _withDirectives((_openBlock(), _createElementBlock("a", {
                  class: _normalizeClass(["navbar-item", { 'has-background-primary': _unref(getRawValue)(option) === currentProjection.value }]),
                  onClick: ($event: any) => (changePerspective(option))
                }, _toDisplayString(_ctx.$t(option.labelKey)), 11, _hoisted_38)), [
                  [_vShow, isProjectionDropdownOpen.value]
                ])
              }), 256))
            ], 512), [
              [_vShow, isProjectionDropdownOpen.value]
            ]),
            (__props.hasEditOptions)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass(["navbar-item", { 'custom-disabled': __props.disabled }]),
                  onClick: zoomIn
                }, _toDisplayString(_ctx.$t('zoomIn')), 3))
              : _createCommentVNode("", true),
            (__props.hasEditOptions)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: _normalizeClass(["navbar-item", { 'custom-disabled': __props.disabled }]),
                  onClick: zoomOut
                }, _toDisplayString(_ctx.$t('zoomOut')), 3))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ], 2)
    ]),
    (showPropertiesModal.value)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 0,
          onClose: dismissPropertiesModal
        }, {
          body: _withCtx(() => [
            _createElementVNode("table", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_41,
                  _createElementVNode("td", null, _toDisplayString(modelProperties.value.nodeName), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelProperties.value.properties, (value, key) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(key), 1),
                    _createElementVNode("td", null, _toDisplayString(value), 1)
                  ]))
                }), 256))
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (showDeleteModal.value)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 1,
          onClose: dismissDeleteModal
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('threeD.deleteTitle')), 1)
          ]),
          actions: _withCtx(() => [
            _createElementVNode("button", {
              class: "button",
              onClick: dismissDeleteModal
            }, _toDisplayString(_ctx.$t('cancel')), 1),
            _createElementVNode("button", {
              class: "button is-danger",
              onClick: handleSubmitForDeleteModal
            }, _toDisplayString(_ctx.$t('delete')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})